<iho-top-nav *ngIf="!isInMapPage" ngSkipHydration (toggleDrawer)="toggleDrawer($event)" [userDataTopNav]="userData()"
  [isLoading]="_isLoadingAuth()"></iho-top-nav>


<main class="relative" role="main">
  <router-outlet></router-outlet>
</main>


<iho-footer *ngIf="!isInMapPage" [ngClass]="isHelpPage ? 'mb-16 md:mb-0 hidden md:block' : 'mb-16 md:mb-0'"
  [phoneNumber]="(resPhoneApi | async)?.SupportPhone"></iho-footer>


 <div class="mb-6">
   <iho-side-menu *ngIf="!isInMapPage" [isOpen]="drawerIsOpen" (toggleDrawer)="toggleDrawer($event)">
   </iho-side-menu>
 </div>